<template>
  <div>
    <FxedTop :isShowBanner="false"></FxedTop>
    <div class="page">
      <div class="pageTitle">您正在浏览： 购物车</div>
      <div class="container">
        <div class="cratlist" v-if="list.length">
          <div class="cartItem" v-for="(item, index) in list" :key="index">
            <div class="cartLeft">
              <img class="icon" :src="item.logo" />
            </div>
            <div class="cartRight">
              <div class="title">
                {{ item.name }}
              </div>
              <div class="groupPrice">
                <div class="groupLecturer">讲师: 易老师</div>
                <div class="price">￥ {{ item.classPrice }}</div>
                <div class="btn" @click="goumai(item)">课程购买</div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="cratlist">
          <div class="empty">
            <div class="emptyImg"></div>
            <div class="emptyText">购物车空空如也</div>
            <div class="emptyBtn">去逛逛</div>
          </div>
        </div>
      </div>
    </div>
    <payment ref="payment" @show="showQrcode" @close="closeQrcode"></payment>
    <Footer></Footer>
  </div>
</template>

<script>
import FxedTop from "@/components/FxedTop";
import Footer from "@/components/Footer";
import Payment from "@/components/payment.vue";
import { buyClass, getGroup } from "@/api/wkApi";
export default {
  components: {
    FxedTop,
    Footer,
    Payment,
  },
  data() {
    return {
      list: [],
    };
  },
  created() {
    try {
      this.list = JSON.parse(localStorage.getItem("cratList")) || [];
    } catch {}
    this.getGroup();
  },
  methods: {
    // 获取猜你喜欢
    async getGroup() {
      const res = await getGroup({ pageNo: 1, pageSize: 3 });
      this.curriculumList = res.result.records;
      let list = this.list;
      for (let index = 0; index < list.length; index++) {
        const element = list[index];
        if (
          this.curriculumList.find(
            (item) => item.id == element.id && item.isJoin == 1
          )
        ) {
          // 移除list, 重新设置购物车缓存
          list.splice(index, 1);
          localStorage.setItem("cratList", JSON.stringify(list));
        }
      }
    },
    showQrcode(msg) {
      console.log(msg);
    },

    closeQrcode(msg) {
      console.log(msg);
    },
    // 购买课程
    async goumai(item) {
      let userInfo = JSON.parse(localStorage.getItem("userInfo"));
      if (!userInfo.isRealName || userInfo.isRealName == 0) {
        // this.$router.push("/login");
        this.$message.warning("请先登录!");
        return;
      }
      if (!userInfo.isCompleteUserInfo || userInfo.isCompleteUserInfo == 0) {
        this.$message.warning("请先完善个人信息!");
        this.$router.push("/perfectInfo");
        return;
      }
      this.$Loading.service({
        lock: true,
        text: "加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let res = await buyClass({ classGroupIds: item.id });
      if (res.code == 200) {
        this.$refs.payment.generateQRCode(
          res.result.payParams.codeUrl,
          item.id,
          () => {
            this.$Loading.service().close();
          }
        );
      } else {
        this.$message.warning(res.message);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.empty {
  text-align: center;
  color: #ccc;
  padding: 100px 0;
  .emptyText {
    margin-bottom: 10px;
  }
}
.container {
  background: #fff;
  border-radius: 10px;
  margin-bottom: 20px;
  .cratlist {
    .cartItem {
      display: flex;
      padding: 20px;
      box-sizing: border-box;
      .cartLeft {
        display: flex;
        margin-right: 40px;
        .icon {
          width: 200px;
          height: 200px;
          background: #f2f2f2;
        }
      }
      .cartRight {
        padding-top: 40px;
        box-sizing: border-box;
        .title {
          font-weight: 400;
          font-size: 18px;
          color: #333333;
          margin-bottom: 20px;
        }
        .groupPrice {
          display: flex;
          align-items: center;

          .groupLecturer {
            font-weight: 400;
            font-size: 18px;
            color: #999999;
            margin-right: 20px;
          }
          .price {
            font-weight: 400;
            font-size: 18px;
            margin-right: 20px;
            color: #f85559;
          }
          .btn {
            padding: 10px;
            border: none;
            color: white;
            border-radius: 4px;
            cursor: pointer;
            background-color: #f85559;
          }
        }
      }
    }
  }
}
</style>
